import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { DateService, FullScreenModalConfig, MobileMaxWidth } from '@lla-platform/core/core-util'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { WeekSelectorDialogComponent } from '../week-selector-dialog/week-selector-dialog.component'

@UntilDestroy()
@Component({
  selector: 'lla-week-selector-filter',
  templateUrl: './week-selector-filter.component.html',
  styleUrls: ['./week-selector-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WeekSelectorFilterComponent implements OnInit, OnChanges {
  @Input() selectedWeeks: number[] = []
  @Input() singleSelection = false
  @Input() includeFuture = false
  @Input() extraClasses = ''

  @Output() selectedWeeksChanged = new EventEmitter<number[]>()

  window = window
  mobileMaxWidth = MobileMaxWidth

  menuIsOpen = false
  selectedWeeksLabel = ''

  constructor(
    private dialogService: MatDialog,
    private dateService: DateService
  ) {}

  ngOnInit(): void {
    this.updateSelectedWeeksLabel()
  }

  ngOnChanges(): void {
    this.updateSelectedWeeksLabel()
  }

  get selectedWeeksValue() {
    return [...this.selectedWeeks]
  }

  onSelectedWeeksChanged(weeks: number[]) {
    this.selectedWeeks = weeks
    this.updateSelectedWeeksLabel()
    this.selectedWeeksChanged.emit(weeks)
  }

  openWeekSelectorModal() {
    this.dialogService
      .open(WeekSelectorDialogComponent, {
        ...FullScreenModalConfig,
        data: {
          selectedWeeks: this.selectedWeeksValue,
          singleSelection: this.singleSelection,
          includeFuture: this.includeFuture
        }
      })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((res: number[]) => {
        if (!res) {
          return
        }
        this.onSelectedWeeksChanged(res)
      })
  }

  getSelectedWeeksLabel(weekNumber: number) {
    return this.dateService.getWeekNumberLabel(weekNumber)
  }

  private updateSelectedWeeksLabel(): void {
    const weeks = this.selectedWeeksValue
    if (weeks.length === 0) {
      this.selectedWeeksLabel = ''
    } else if (weeks.length === 1) {
      this.selectedWeeksLabel = this.getSelectedWeeksLabel(weeks[0])
    } else {
      this.selectedWeeksLabel = `${weeks.length} weeks selected`
    }
  }
}
